// src/components/shipment/CountryBadge.jsx
import React from 'react';

// Get flag image URL from flagcdn
const getFlagUrl = (countryCode) => {
    if (!countryCode) return null;
    return `https://flagcdn.com/24x18/${countryCode.toLowerCase()}.png`;
};

const PORT_COUNTRY_MAP = {
    SUORF: "US", USCHI: "US", USLAX: "US", USNYC: "US", USSEA: "US", USHOU: "US", USQ6T: "US", USMIA: "US", USSAV: "US", USBAL: "US", USBOS: "US", USJAX: "US", USPHL: "US",
    USMIA: "US", USSAV: "US", USBAL: "US", USBOS: "US", USJAX: "US", USPHL: "US", USNYQ: "US", USLGB: "US", USOAK: "US", USNLT: "US",

    INNSA: "IN", INMUN: "IN", INMAA: "IN", INBOM: "IN", INCCU: "IN",

    CNSHA: "CN", CNNGB: "CN", CNSZX: "CN", CNTAO: "CN", CNXMN: "CN", CNDAL: "CN", CNXGG: "CN",

    SGSIN: "SG",

    AEDXB: "AE", AEJEA: "AE", AEAUH: "AE",

    GBFXT: "GB", GBLIV: "GB", GBSOU: "GB", GBTIL: "GB",

    NLRTM: "NL", NLAMS: "NL",

    DEHAM: "DE", DEBREM: "DE",

    FRLEH: "FR", FRFOS: "FR",

    JPYOK: "JP", JPTYO: "JP", JPKOB: "JP",

    KRPUS: "KR", KRINC: "KR",

    AUSYD: "AU", AUMEL: "AU", AUBNE: "AU",

    CAVAN: "CA", CATOR: "CA", CAMTR: "CA",

    BRSSZ: "BR", BRRIG: "BR",

    MXZLO: "MX", MXVER: "MX",

    ESVLC: "ES", ESBCN: "ES",

    ITGOA: "IT", ITGIT: "IT",

    BEANR: "BE", BETTT: "BE",

    SAJED: "SA", SADMM: "SA",

    GBNWY: "GB", GBLIV: "GB", GBSOU: "GB", GBTIL: "GB",

    PLGDN: "PL", PLWRO: "PL",

    JMNYM: "JM", JMKMN: "JM",
};

const getCountryCodebyPort = (portCode) => {
    if (!portCode || typeof portCode !== "string") return null;
    return PORT_COUNTRY_MAP[portCode.trim().toUpperCase()] || portCode ? portCode.substring(0, 2).toUpperCase() : null;
};

const getCountryCode = (location) => {
    if (!location) return null;

    const match = location.match(/\[(.*?)\]/);
    return match ? match[1].substring(0, 2).toUpperCase() : null;
};

/* ---------------- COMPONENT ---------------- */

const CountryBadge = ({ code, isOrigin, variant = "circle" }) => {
    if (!code) return null;

    // ✅ FIX: use let instead of const
    let countryCode = "XX";

    if (code.length === 2) {
        countryCode = code.toUpperCase();
    } else {
        countryCode =
            getCountryCodebyPort(code) ||
            getCountryCode(code) ||
            "XX"; // ✅ safe fallback
    }

    /* -------- CIRCLE -------- */
    if (variant === "circle") {
        return (
            <div
                className={`w-12 h-12 rounded-full flex flex-col items-center justify-center shadow-md ${isOrigin
                    ? 'bg-gradient-to-br from-blue-500 to-blue-600'
                    : 'bg-gradient-to-br from-emerald-500 to-emerald-600'
                    }`}
            >
                <img
                    src={getFlagUrl(countryCode)}
                    alt={countryCode}
                    className="w-6 h-4 object-cover rounded-sm"
                    onError={(e) => (e.currentTarget.style.display = 'none')}
                />
                <span className="text-white text-[8px] font-bold mt-0.5">
                    {countryCode}
                </span>
            </div>
        );
    }

    /* -------- BOX -------- */
    return (
        <div className="flex items-center gap-1.5 rounded px-1.5 py-0.5 bg-slate-100 dark:bg-slate-700">
            <img
                src={getFlagUrl(countryCode)}
                alt={countryCode}
                className="w-5 h-4 object-cover rounded-sm"
                onError={(e) => (e.currentTarget.style.display = 'none')}
            />
            <span className="text-xs font-bold text-slate-700 dark:text-slate-300">
                {countryCode}
            </span>
        </div>
    );
};

/* ---------------- INLINE FLAG ---------------- */

export const InlineCountryFlag = ({ code, size = "xs" }) => {
    if (!code) return null;

    let countryCode = "XX";

    if (code.length === 2) {
        countryCode = code.toUpperCase();
    } else {
        countryCode =
            getCountryCodebyPort(code) ||
            getCountryCode(code) ||
            "XX";
    }

    const sizeClasses = {
        xs: "w-4 h-3",
        sm: "w-5 h-4",
        md: "w-6 h-5",
        lg: "w-8 h-6"
    };

    return (
        <img
            src={getFlagUrl(countryCode)}
            alt={countryCode}
            className={`${sizeClasses[size]} object-cover rounded-sm inline-block`}
            onError={(e) => (e.currentTarget.style.display = 'none')}
        />
    );
};

export default CountryBadge;
